var _defs, _ellipse, _path, _path2, _ellipse2, _ellipse3, _ellipse4, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdcInd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.35 29.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#1a8867;}.cls-3{fill:#1c8867;}.cls-4{fill:#554d4b;}.cls-5{fill:#8a807d;}.cls-6{fill:#c1bbb9;}.cls-7{fill:#272728;}.cls-8{fill:#62be9c;}.cls-9{fill:#62be9b;}.cls-10{fill:#62bd9b;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 37.92,
    cy: 15.06,
    rx: 10.91,
    ry: 10.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.14,15.3A14.3,14.3,0,1,1,43,1,14.29,14.29,0,0,1,57.14,15.3Zm-23.08-.47c-.75,2.3-.35,3.1,1.84,3.69a15.66,15.66,0,0,0,3.88.64c.93,0,1.34.29,1.19,1.23a4.33,4.33,0,0,0,0,.72c0,2.83,0,2.83,2.84,2.74a1.77,1.77,0,0,1,.23,0c.52,0,.71-.19.7-.7,0-1,0-2.07,0-3.11,0-.6.19-.83.82-.85a18.38,18.38,0,0,0,4.23-.67c2.2-.58,2.59-1.38,1.85-3.69a2.67,2.67,0,0,0-1.64-.9,17,17,0,0,0-4.48-.71c-.93,0-.73-.6-.78-1.13s.13-.88.79-.85c1.32,0,2.65-.07,4,0s1-.69,1-1.38.16-1.36-1-1.34c-4.16.08-8.32,0-12.48,0-1.81,0-1.78,0-1.76,1.8,0,.68.22.9.9.88,1.32,0,2.64,0,4,0,.64,0,1,.13.92.85s0,1.18-.92,1.14a9,9,0,0,0-2.37.25C36.43,13.77,35.05,13.79,34.06,14.83Z",
    transform: "translate(-4.79 -0.72)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.32,15.85c.53.67-.19.75-.48.87a13,13,0,0,1-3.94.9,32,32,0,0,1-11-.55,6.62,6.62,0,0,1-1.44-.56c-.37-.2-.25-.42-.06-.65a18.41,18.41,0,0,1,5.58-1.22c.75-.07,1.16.11,1,.95s.2,1.09,1,1a6.87,6.87,0,0,1,1.2,0c1,0,1.89.12,1.6-1.36-.13-.71.46-.61.88-.58A17.65,17.65,0,0,1,51.32,15.85Z",
    transform: "translate(-4.79 -0.72)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 14.53,
    cy: 28.92,
    rx: 2.55,
    ry: 0.17
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 14.53,
    cy: 0.12,
    rx: 2.21,
    ry: 0.17
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 28.93,
    cy: 14.52,
    rx: 0.17,
    ry: 1.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M33.6,13.92v2.64c.18.72-.22,1.36-.27,2.05a8.46,8.46,0,0,1-.57,1.79,14.74,14.74,0,0,1-2.43,4.16,13,13,0,0,1-3,2.68A14,14,0,0,1,23.68,29a5.49,5.49,0,0,1-2.56.48h-3.6a11.91,11.91,0,0,1-5.91-1.93A14.06,14.06,0,0,1,8,24.34,14.9,14.9,0,0,1,5.5,19.86a18.11,18.11,0,0,1-.7-6.54c.56-1.84.88-3.74,2-5.4A17.33,17.33,0,0,1,9.28,4.76,15,15,0,0,1,15,1.45,6.48,6.48,0,0,1,17.76,1h3.12a9.92,9.92,0,0,1,3.6.84A13.55,13.55,0,0,1,29,4.59a16.56,16.56,0,0,1,2.28,2.53c.32.5.55,1,.86,1.56A18.68,18.68,0,0,1,33.59,13,3.35,3.35,0,0,1,33.6,13.92Zm-7.48,7.9V11.75H25.07l-.29-.29c-.17-.36.08-.79-.19-1.18h-1L23.27,10V8.69H21.81v1.57c-.49.17-1-.08-1.45.18v1.33H19v1.45h2l.85.85v7.75Zm-8.64,0V14.7H16v1.39H14.63v1.45H13.25v4.28ZM13.22,13.2c1.25,0,2.41,0,3.56,0a.8.8,0,0,0,.72-.36V8.94c-.61-.57-1.36-.23-2-.29s-1.49,0-2.25,0Z",
    transform: "translate(-4.79 -0.72)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M26.12,21.82H21.87V14.07L21,13.22H19V11.77h1.35V10.44c.47-.26,1,0,1.45-.18V8.69h1.46V10l.33.33h1c.27.39,0,.82.19,1.18l.29.29h1.05Z",
    transform: "translate(-4.79 -0.72)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M17.48,21.82H13.25V17.54h1.38V16.09H16V14.7h1.44Z",
    transform: "translate(-4.79 -0.72)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M13.22,13.2V8.64c.76,0,1.51,0,2.25,0s1.42-.28,2,.29v3.91a.8.8,0,0,1-.72.36C15.63,13.18,14.47,13.2,13.22,13.2Z",
    transform: "translate(-4.79 -0.72)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdcInd);
export default __webpack_public_path__ + "static/media/usdc-ind.bf5b9ca6.svg";
export { ForwardRef as ReactComponent };